/** **   request.js   ****/
// 导入axios
import Vue from 'vue'
import axios from 'axios'
import { addNewColor } from '@ost/static'
import {Toast} from 'vant'
import store from '../store'
import router from '../router/index'
var root = process.env.WWW_API_ROOT
// 使用element-ui Message做消息提醒
// import { Message} from 'ant-design-vue';
// 1. 创建新的axios实例，
const service = axios.create({
  // 公共接口--这里注意后面会讲
  baseURL: root,
  // 超时时间 单位是ms，这里设置了3s的超时时间
  timeout: 3 * 100000
})
const centerService = axios.create({
  // 公共接口--这里注意后面会讲
  baseURL: '/base-api',
  // 超时时间 单位是ms，这里设置了3s的超时时间
  timeout: 3 * 100000
})

const err = (error) => {
  if (error.response) {
    const data = error.response.data
    const token = Vue.ls.get('ACCESS_TOKEN')
    if (error.response.status === 403) {
      Toast.error('你没有权限')
    }
    if (error.response.status === 401) {
      Toast.error('登录失效，请重新登录')
      Vue.ls.set('ACCESS_TOKEN', '')
      store.dispatch('Logout').then(() => {
        Vue.ls.remove('ACCESS_TOKEN')
        let isPrdUrl = window.location.href
        let str = ''
        let str1 = ''
        let str3 = ''
        str3 = 'STATE'
        if (isPrdUrl.indexOf('m.ippmaster.com') != -1) {
          str = 'wxc0eebdec65b19c45'
          str1 = 'm.ippmaster.com%2fsystem'
        } else if (isPrdUrl.indexOf('m1.mp.ippmaster.com') != -1 || isPrdUrl.indexOf('m1.ost.com') != -1) {
          str = 'wx9c6b7411242fab1a'
          str1 = 'm1.mp.ippmaster.com%2fsystem'
        } else if (isPrdUrl.indexOf('m.mp.ippmaster.com') != -1 || isPrdUrl.indexOf('m.ost.com') != -1) {
          str = 'wxd171949afbc94bbb'
          str1 = 'm.mp.ippmaster.com%2fsystem'
        } else {
          str = 'wxf00dd2ff877812bf'
          str1 = 'wjw.mp.ippmaster.com%2fsystem'
        }
        let ua = navigator.userAgent.toLowerCase() // 判断是否在微信浏览器
        let isWeixin = ua.indexOf('micromessenger') != -1 // 判断是否在微信浏览器
        let phone = navigator.userAgent// 设备机型的相关信息
        phone = phone.substring(phone.indexOf('(') + 1, phone.indexOf(';'))// 处理信息，输出phone
        // 判断是手机端并且在 微信浏览器打开
        if (isWeixin && (phone.indexOf('Windows') == -1 && phone.indexOf('Macintosh') == -1)) {
          let str2 = `https://open.weixin.qq.com/connect/oauth2/authorize?appid=${str}&redirect_uri=http%3a%2f%2f${str1}%2f&response_type=code&scope=snsapi_userinfo&state=${str3}#wechat_redirect`
          window.location.href = str2
        } else {
          let loginTest = ''
          let href = window.location.href
          if (href.indexOf('m1.ost.com') != -1) {
            loginTest = 'http://m1.ost.com/system/user/loginTest'
          } else if (href.indexOf('m.ost.com') != -1) {
            loginTest = 'http://m.ost.com/system/user/loginTest'
          } else if (href.indexOf('uat-m.ippmaster.com') != -1) {
            loginTest = 'https://uat-m.ippmaster.com/system/user/loginTest'
          } else if (href.indexOf('m.ippmaster.com') != -1) {
            loginTest = 'https://m.ippmaster.com/system/user/loginTest'
          } else {
            loginTest = 'http://192.168.10.108:8080/system/user/loginTest'
          }
          window.location.href = loginTest
        }
      })
    }
    if (error.response.status === 412) {
      Toast.error('The service is Lost')
    }
  }
  return Promise.reject(error)
}
centerService.interceptors.request.use(config => {
  // Toast.loading('加载中...')
  const token = Vue.ls.get('ACCESS_TOKEN')
  // console.log(config)
  if (store.state.user && store.state.user.token && token && store.state.user.token != token) {
    window.location.reload()
  }
  config.headers['Timestamp'] = '3.22.22'
  config.headers['current-systemtype'] = '01'
  config.headers['systemType'] = '01'
  config.headers['platform'] = '01'
  config.headers['request-platform'] = '00'
  config.headers['Accept-Language'] = 'zh-CN'
  config.headers['Content-Language'] = 'zh-CN'
  if (token) {
    config.headers['token'] = token
  }
  console.log(config, 'configconfig')
  return addNewColor(config)
}, err)

centerService.interceptors.response.use(
  response => {
    return response.data
  }, err)
export function post (url, data, str) {
  let headers = {}
  if (str && str == 'params') {
    let formData = new FormData()
    for (const key in data) {
      formData.append(key, data[key])
      headers = {
        processData: 'false',
        contentType: 'false'
      }
    }
    data = formData
  }
  return new Promise((resolve, reject) => {
    service.post(url, data, headers)
      .then(response => {
        resolve(response)
      }, err => {
        reject(err)
      })
  })
}
export function payPpost (url, data, str, pwd) {
  let headers = {}
  if (str && str == 'params') {
    let formData = new FormData()
    for (const key in data) {
      formData.append(key, data[key])
      headers = {
        processData: 'false',
        contentType: 'false'
      }
    }
    data = formData
  }
  headers = {
    'Authorization': pwd,
    'Content-Type': 'application/json'
  }
  return new Promise((resolve, reject) => {
    centerService.post(url, data, {headers: headers})
      .then(response => {
        resolve(response)
      }, err => {
        reject(err)
      })
  })
}

export function get (url, params) {
  console.log(centerService, 'centerService5555')
  return new Promise((resolve, reject) => {
    centerService.get(url, {
      params: params
    }).then(res => {
      resolve(res)
    }).catch(err => {
      reject(err)
    })
  })
}
export default {post, get, service}



// WEBPACK FOOTER //
// ./src/util/centerRequest.js